import React from "react";

import InstagramDark from "../../../../../images/dataViz/instagramDark.svg";
import FacebookDark from "../../../../../images/dataViz/facebookDark.svg";
import SpotifyDark from "../../../../../images/dataViz/spotifyDark.svg";
import TikTokDark from "../../../../../images/dataViz/tiktokDark.svg";
import LinkedInDark from "../../../../../images/dataViz/linkedInDark.svg";
import RedditDark from "../../../../../images/dataViz/redditDark.svg";
import YoutubeDark from "../../../../../images/dataViz/youtubeDark.svg";
import PinterestDark from "../../../../../images/dataViz/pinterestDark.svg";
import SnapchatDark from "../../../../../images/dataViz/snapchatDark.svg";
import GoogleSearchDark from "../../../../../images/dataViz/googleSearchDark.svg";
import EbayDark from "../../../../../images/dataViz/ebayDark.svg";
import XDark from "../../../../../images/dataViz/XDark.svg";
import IndeedDark from "../../../../../images/dataViz/indeedDark.svg";
import GoogleDisplayDark from "../../../../../images/dataViz/googleDisplayDark.svg";

function useChannelsIcon() {
  const renderIcons = (channel) => {
    switch (channel) {
      case "facebook":
        return <FacebookDark />;
      case "instagram":
        return <InstagramDark />;
      case "spotify":
        return <SpotifyDark />;
      case "tiktok":
        return <TikTokDark />;
      case "linkedin":
        return <LinkedInDark />;
      case "reddit":
        return <RedditDark />;
      case "youtube":
        return <YoutubeDark />;
      case "pinterest":
        return <PinterestDark />;
      case "snapchat":
        return <SnapchatDark />;
      case "google-search":
        return <GoogleSearchDark />;
      case "ebay-kleinanzeigen":
        return <EbayDark />;
      case "twitter":
        return <XDark />;
      case "indeed":
        return <IndeedDark />;
      case "google-display":
        return <GoogleDisplayDark />;

      default:
        return null;
    }
  };

  return { renderIcons };
}

export default useChannelsIcon;
